import { Featured, HistoryRecord } from '@skinsoft/ui';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

import { ThesaurusTermDataStore, thesaurusTermSelectors } from '@skinsoft/entity';


export function resolveDescription(
    source$: Observable<Featured | HistoryRecord>,
): Observable<Featured | HistoryRecord> {
    const thesaurusDataStore = ThesaurusTermDataStore.getInstance();
    return source$.pipe(
        switchMap(featured => {
            if (!featured.description) {
                return source$;
            }

            return thesaurusDataStore.fetchOne(featured.description as string).pipe(
                take(1),
                map(thesaurusTerm => ({
                    ...featured,
                    description: thesaurusTermSelectors.preferredTerm(thesaurusTerm),
                })),
            );
        }),
    );
}
